<template>
               <div class="bar">
                  <div class="active_time">{{ time }}</div>
                  <div class="progress_bar" ref="barBg" @touchstart.prevent="clickBg">
                      <div class="bar_color" :style="{width:length}"></div>
                      <div class="bar_pan"
                       :style="{left:length}"
                        @touchstart.prevent="start"
                        @touchmove.prevent="move"
                        @touchend="end" 
                      ></div>
                  </div>
                  <div class="total_time">{{ formatSeconds(parseInt(allTime))}}</div>
              </div>
</template>

<script>
export default {
    name: '',
    data() { 
        return {
            length,
            touch: {}
        }
    },
        props: {
            allTime: {
            type: Number
            },
            time: {
            type: String
            },
            width: {
            type: Number
            },
            index: {
            type: Number
        }
    },
    computed: {},

    created() {

    },
    mounted() {

    },
      watch: {
    width: function (val) {
      if (val && !this.touch.state) {
        val = val + '%'
        this.length = val
      }
    }
  },
    methods:{
            /**
         * 点击小圆点
         */
        start (e) {
        this.touch.state = true
        const left = this.$refs.barBg.offsetLeft
        this.touch.startX = e.changedTouches[0].pageX - left
        this.touch.width = this.$refs.barBg.clientWidth
        },
        clickBg (e) {
        this.touch.width = this.$refs.barBg.clientWidth
        const left = this.$refs.barBg.offsetLeft
        this.touch.endX = e.changedTouches[0].pageX - left
        const offsetWidth = this.touch.endX / this.touch.width * 100
        // console.log(offsetWidth)

        this._changeWidth(offsetWidth)
        this.$emit('time', offsetWidth, isNaN(this.index) ? '' : this.index)
        },
        move (e) {
        if (!this.touch.state) {
            return
        }
        const left = this.$refs.barBg.offsetLeft
        const deltaX = e.changedTouches[0].pageX - left
        const width = Math.min(Math.max(0, deltaX), this.touch.width)
        this.touch.offsetWidth = width / this.touch.width * 100
        this._changeWidth(this.touch.offsetWidth)
        },
        _changeWidth (val) {
        this.length = val + '%'
        },
        end () {
        this.touch.state = false
        this.$emit('time', this.touch.offsetWidth, isNaN(this.index) ? '' : this.index)
        },

        formatBit (val) {
            val = +val
            return val > 9 ? val : '0' + val
            },
        　　 // 秒转时分秒，求模很重要，数字的下舍入
        formatSeconds (time) {
            let min = Math.floor(time % 3600)
            let val = this.formatBit(Math.floor(time / 3600)) + ':' + this.formatBit(Math.floor(min / 60)) + ':' + this.formatBit(time % 60)
            return val
            },
    },

      filters: {
    /**
     * 将毫秒数转换为正常的时间
     *  212245 ==> 03:32
    */
    setTime (value) {
      if (!value) return ''
      let min = parseInt(value / (1000 * 60))
      if (min < 10) {
        min = '0' + min
      }
      let sec = parseInt(value % (1000 * 60) / 1000)
      if (sec < 10) {
        sec = '0' + sec
      }
      value = `${min}:${sec}`
      return value
    }
  }
 }
</script>

<style  scoped>
</style>